import shortName from '@js/config/short-name'
import HS from 'heroes_share'

const { unitShortName } = shortName

const getDefaultState = () => {
  return {
    // 副本
    fubenState: {},
  }
}

const state = getDefaultState()

const getters = {

}

const actions = {

}

const mutations = {

}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
